import type { Key, ReactNode } from 'react';
import React from 'react';
import { useStyletron } from 'baseui';
import { VIRTUAL_AXIS } from './constants';
import type { VirtualAxisT, VirtualItemT } from './types';
type VirtualTrackPropsT = {
  items: VirtualItemT[];
  axis: VirtualAxisT;
  scrollMargin: number;
  getKey: (index: number) => Key;
  renderItem: (index: number) => ReactNode;
};

/**
 * Positions one axis of virtual items (X for columns, Y for rows). The parent must
 * be `position: relative` and sized to the virtualizer's total size.
 */
export const VirtualTrack = ({
  items,
  axis,
  scrollMargin,
  getKey,
  renderItem
}: VirtualTrackPropsT) => {
  const [css] = useStyletron();
  const isColumn = axis === VIRTUAL_AXIS.column;
  return <>
      {items.map(item => {
      const offset = item.start - scrollMargin;
      return <div key={getKey(item.index)} className={css({
        position: 'absolute',
        top: '0px',
        left: '0px',
        width: isColumn ? `${item.size}px` : '100%',
        height: isColumn ? '100%' : `${item.size}px`,
        transform: isColumn ? `translateX(${offset}px)` : `translateY(${offset}px)`
      })}>
            {renderItem(item.index)}
          </div>;
    })}
    </>;
};